<template>
  <div class="word_upload">
  
    <el-upload
      :action="ossData.host"
      :data="aliData"
      :headers="uploadHeaders"
      :show-file-list="false"
      :on-exceed="handleExceed"
      :on-success="handSuccess"
      :on-progress="uploadProgress"
      :on-change="handleChange"
      :before-upload="beforeUpload"
      :on-error="uploadFileError"
    >
      <el-button
        type="text"
        icon="el-icon-upload"
      >
        上传</el-button
      >
    </el-upload>
    <div class="progress_wrapper" v-if="progressFlag">
      <el-progress
        class="progress_modal"
        type="circle"
        :percentage="uploadPercent"
      ></el-progress>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  generatePostPolicyVideo,
  generatePresignedUrl
} from "@/api/zd/dictionaries";

export default {
  name: "wordUpload",
  data() {
    return {
      onLoading: false,
      progressFlag: false,
      uploadPercent: 0,
      client: null,
      uploadNum: 0,
      filesLength: 0,
      timeStatus: false,
      files: {},
      aliData:{},
      fileNameList:[],
      // ossData:{},
      fileList:[]
    };
  },
  computed: {
    uploadHeaders() {
      return {
        "Blade-Auth": "bearer " + Cookies.get("saber-access-token"),
      };
    },
  },
  watch: {
    // fileMenuUrlName:{
    //   handler(val){
    //      this.configData();
    //   },
    //   immediate:true
    // }
  },
  props: {
    ossData: {
      type: Object,
      default: ()=>{},
    },
    fileMenuUrlName: {
      type: String,
      default: "",
    },
    tableIndex: {
      type: Number,
      default: -1,
    },
  },
  created() {
    //  this.configData();
  },
  destroyed() {
    this.timeStatus = true;
    window.clearTimeout(this.timer); //关闭
  },
  methods: {
    configData() {
      let that = this;
      generatePostPolicyVideo({ dir: "" }).then((result) => {
       
        this.ossData = {
          policy: result.data.data.policy,
          OSSAccessKeyId: result.data.data.accessid,
          signature: result.data.data.signature,
          host: result.data.data.host,
          success_action_status: 200,
        };
        if (that && !that.timeStatus) {
              that.timer = window.setTimeout(() => {
                that.configData();
              }, 10*1000*60);//token过期时间10分钟
       }
      });
    },
    beforeUpload(files) {
      let that=this
      let fileMenuUrlName = this.fileMenuUrlName
      ? this.fileMenuUrlName.replace(/\\/g, "/").replace("/", "")
      : "";
      this.files = files;
      this.filesLength = this.filesLength + 1;
      
      that.aliData.key = fileMenuUrlName + "/" + files.uid + "_" + files.name
      that.aliData.policy = that.ossData.policy
      that.aliData.OSSAccessKeyId = that.ossData.OSSAccessKeyId
      that.aliData.signature =that.ossData.signature ,
      that.aliData.success_action_status = "200",
      // that.aliData.name = files.uid + "_" + files.name
      that.aliData.name = files.name
      

      
    },
    handleExceed(files, fileList) {},
    uploadProgress(event, file, fileList) {
      this.progressFlag = true;
      let max = Math.max.apply(
        Math,
        fileList.map(function (value) {
          return value.size;
        })
      );
      if (file.size == max) {
        this.uploadPercent = Math.floor(event.percent);
        if (this.uploadPercent == 100) {
          this.uploadPercent = 99;
        }
        
        
        
      }
    },
    handSuccess(response, files, fileList) {
      
        let fileMenuUrlName = this.fileMenuUrlName
        ? this.fileMenuUrlName.replace(/\\/g, "/").replace("/", "")
        : "";
        this.$message({
              type: "success",
              message: "上传成功!",
            });
        this.progressFlag = false;
        this.uploadPercent = 0;
        this.$emit("showFileName", [{name:this.aliData.key}], this.tableIndex);

      
      

    },
    handleRemove(file, fileList) {
      
    },
    //上传失败
    uploadFileError(){
      this.progressFlag = false;
      this.uploadPercent=0
      this.$message.error("上传失败！")
    },
    handlePreview(file) {},
    
    
    
  },
};
</script>

<style lang="scss" scoped>

.progress_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0,0.3);
  z-index: 2000;
  .progress_modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

</style>
